export function formatPhoneForTelLink( tel: string, includePlus = false ): string {
    let formatted = tel.replace( /[^\d+]/g, '' );

    if ( /^00[0-9]{1,}/g.test( formatted ) ) {
        formatted = formatted.substring( 2 );

        if ( includePlus ) {
            formatted = `+${formatted}`;
        }
    }

    return formatted;
}
